export function removeNullableObjectFields(object: { [p: string]: unknown }) {
  return Object.fromEntries(Object.entries(object).filter(([, v]) => v !== null))
}
